import * as XLSX from 'xlsx';
import type { ApplicantExportRow } from './applicant-export.util';

const SHEET_HEADER_MAP: Record<string, keyof ApplicantExportRow> = {
  'student name': 'fullName',
  'contact number': 'phoneNumber',
  'student/lead id': 'leadId',
  'lead source': 'leadSource',
  'lead date': 'leadDate',
  'assigned counsellor': 'assignedCounsellor',
  'student details': 'studentDetails',
  status: 'status',
  'enrollment type': 'enrollmentType',
  enrollment: 'enrollmentType',
  'amount quoted + 18% gst': 'amountQuotedWithGst',
  'amount recieved': 'amountReceived',
  'amount received': 'amountReceived',
  'pending amount': 'pendingAmount',
  documents: 'documents',
  'test opted for from us': 'testOptedFor',
  'assigned application handler': 'assignedApplicationHandler',
  'application tracking': 'applicationTracking',
  'universities applied to': 'universitiesAppliedTo',
  'universities offers received from': 'universitiesOffersReceived',
  'universities offers rejected from': 'universitiesOffersRejected',
  note: 'note',
};

function normalizeHeader(header: string): string {
  return header.trim().toLowerCase().replace(/\s+/g, ' ');
}

function toCellText(value: unknown): string {
  if (value == null) return '';
  return String(value).trim();
}

function mapSheetRow(raw: Record<string, unknown>): ApplicantExportRow {
  const row: Partial<ApplicantExportRow> = {};
  for (const [header, value] of Object.entries(raw)) {
    const key = SHEET_HEADER_MAP[normalizeHeader(header)];
    if (!key) continue;
    row[key] = toCellText(value);
  }
  return row as ApplicantExportRow;
}

function hasImportableRow(row: ApplicantExportRow): boolean {
  return Boolean(row.fullName?.trim() || row.phoneNumber?.trim() || row.leadId?.trim());
}

export async function parseApplicantsExcel(file: File): Promise<ApplicantExportRow[]> {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: 'array' });
  const sheetName = workbook.SheetNames[0];
  if (!sheetName) return [];

  const sheet = workbook.Sheets[sheetName];
  const table = XLSX.utils.sheet_to_json<Record<string, unknown>>(sheet, { defval: '' });
  return table.map((row) => mapSheetRow(row)).filter((row) => hasImportableRow(row));
}
